<template>
  <div class="container">
    <div class="goBackBtn" @click="$router.go(-1) & closeGA4Click('click', 'cerrar', 'politica de cookies')">
      <h2>
        X
      </h2>
    </div>
    <div id="cookies-policy" class="cookies-policy" v-html="cookies"></div>
    <!-- OneTrust Cookies List start -->
    <div id="ot-sdk-cookie-policy" data-document-language="true"></div>
    <!-- OneTrust Cookies List end -->
  </div>
</template>

<script>
import Axios from "axios";
import tagFunctions from "@/utils/tagFunctions.js";
export default {
  name: "Cookies",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx",
    },
  },
  data() {
    return {
      cookies: "",
    };
  },
  async mounted() {
    window.scrollTo(0,0)
    tagFunctions.user_interactionPush(
      "view",
      "politica de cookies",
      "footer"
    );
    // let serviceResponse = await Axios.get(
    //   "https://api-mx-marketing.azure-api.net/sitios/cookies/aviso/V1"
    // );
    let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/cookies/aviso/V2')
    this.cookies = serviceResponse.data
      .replace("{", "")
      .replace('"body":"', "")
      .replace(
        `";
        }`,
        ""
      );
    
    if (this.$route.path === '/cookies') {
      this.$nextTick(() => {
        setTimeout(() => {
          if (typeof Optanon !== 'undefined' && typeof Optanon.initializeCookiePolicyHtml === 'function') {
            Optanon.initializeCookiePolicyHtml();
          }
        }, 100);
      });
    }
  },
  methods: {
    closeGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
  },
  watch: {
    '$route.path'(newPath) {
      if (newPath === '/cookies') {
        this.$nextTick(() => {
          setTimeout(() => {
            if (typeof Optanon !== 'undefined' && typeof Optanon.initializeCookiePolicyHtml === 'function') {
              Optanon.initializeCookiePolicyHtml();
            } else {
              console.warn('OneTrust not yet loaded or method missing');
            }
          }, 100);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.container {
  background-image: url("/Back-2.png");
  background-position: center;
  background-size: 100%;
}

.goBackBtn {
  display: flex;
  flex-direction: row;
  //width: 130px;
  width: 70px;
  background-color: transparent;
  border: none;
  color: $green-pantone-7729c;
  font-family: $font-dinbold;
  //margin-left: 2rem;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  h2 {
    color: $green-pantone-7729c !important;
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    //width: 80px;
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}
.cookies-policy {
  font-family: "Wood-Bonnet-Grotesque" !important;
  font-size: 1.7vw !important;
  margin-right: 16.2pt !important;
  margin-left: 16.2pt !important;
  text-align: justify;
  color: $green-pantone-7729c !important;
  padding-inline: 2vw;
  padding-bottom: 5vw;
  padding-top: 6vw !important;
  p {
    margin-bottom: 2vw;
  }
  @media (max-width: 768px) {
    font-size: 5.5vw !important;
    margin-right: 10.2pt !important;
    margin-left: 10.2pt !important;
    padding-top: 14vw !important;
  }
}

</style>
<style lang="scss">
  table {
    width: 100% !important;
    border-collapse: collapse !important;
    @media (max-width: 768px) {
      width: 0% !important;
    }
  }
  tr {
    font-size: 1.7vw !important;
    @media (max-width: 768px) {
      font-size: 5vw !important;
    }
  }
  th {
    border: solid 1px;
    @media (max-width: 768px) {
      font-size: 5vw !important;
    }
  }
  td {
    border: solid 1px;
    @media (max-width: 768px) {
      font-size: 5vw !important;
    }
  }
</style>
